export default "__VITE_ASSET__DBJEVFtZ__"